module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley-rw"
  }, [_c('section', {
    staticClass: "body-rw Chapter-rw",
    attrs: {
      "epub:type": "bodymatter chapter",
      "id": "Chapter3"
    }
  }, [_c('div', {
    staticClass: "title-block-rw",
    attrs: {
      "id": "title-block8"
    }
  }, [_c('p', {
    staticClass: "title-num-rw",
    attrs: {
      "id": "title-num3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/TOC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter Two")])])]), _c('p', {
    staticClass: "firstpara-rw",
    attrs: {
      "id": "p213"
    }
  }, [_c('span', {
    staticClass: "raisedcap-rw"
  }, [_vm._v("W")]), _vm._v("illow. I’m so sorry for your loss.” Mason McMillan, long-time lawyer for the MacKenzie family, paused in the doorway to give the woman an awkward hug while juggling his briefcase in one hand and his wide-brimmed hat in the other.\n         ")]), _c('p', {
    attrs: {
      "id": "p214"
    }
  }, [_vm._v("“Thank you, Mason.” She took his dripping hat and draped it on a hook before looking past him to the tall, handsome man standing behind him.")]), _c('p', {
    attrs: {
      "id": "p215"
    }
  }, [_vm._v("“Oh, sorry.” He turned. “Willow, this is my son, Lance. I’ve been easing him into my law practice, and now I’m comfortable leaving all my clients in his capable hands.”")]), _c('p', {
    attrs: {
      "id": "p216"
    }
  }, [_vm._v("“Lance. If you’re half as good as your father, I know you’ll make him proud.” She shook his hand before leading both men into the kitchen.")]), _c('p', {
    attrs: {
      "id": "p217"
    }
  }, [_vm._v("“The roads are practically washed out by all this rain.” Mason stepped around her and set down the briefcase on the kitchen table before offering his handshake first to Brady Storm, then to Maddock, and then to Whit, murmuring words of sympathy as he did. His son smoothly followed suit.")]), _c('p', {
    attrs: {
      "id": "p218"
    }
  }, [_vm._v("“Thanks, Mason. Lance.” Mad pointed to the kitchen counter. “Would you prefer coffee or something stronger?”")]), _c('p', {
    attrs: {
      "id": "p219"
    }
  }, [_vm._v("Lance smiled his gratitude. “After a hundred miles in this weather, I wouldn’t mind a splash of your fine Irish whiskey in my coffee.” He turned to Mason. “You could probably use some, too, Dad. And all of you.”")]), _c('p', {
    attrs: {
      "id": "p220"
    }
  }, [_vm._v("Mad turned to his daughter-in-law, his grandson, and the ranch foreman. “Care to join us?”")]), _c('p', {
    attrs: {
      "id": "p221"
    }
  }, [_vm._v("Willow glanced at her son, then at their foreman, and when both nodded, she did the same.")]), _c('p', {
    attrs: {
      "id": "p222"
    }
  }, [_vm._v("“Done.” Mad wheeled his chair across the room and filled six cups with steaming coffee, then added the bottle of whiskey to the tray that fit perfectly over the arms of his chair.")]), _c('p', {
    attrs: {
      "id": "p223"
    }
  }, [_vm._v("Seeing it, Lance remarked, “My father told me you invent things, Mad. That tray one of your inventions?”")]), _c('p', {
    attrs: {
      "id": "p224"
    }
  }, [_vm._v("“Yeah.” Mad looked pleased that the younger lawyer had noticed. “I’m always looking for things that can make my life a bit easier.”")]), _c('p', {
    attrs: {
      "id": "p225"
    }
  }, [_vm._v("Minutes later, as they gathered around the big oak table, Mason lifted his cup in a salute. “Here’s to Bear.”")]), _c('p', {
    attrs: {
      "id": "p226"
    }
  }, [_vm._v("The others followed suit and sipped while he shook his head. “Sorry. I still can’t believe he’s gone.” He looked around the table, seeing the lingering shock in all their eyes. “I know I’m preaching to the choir, but of all the people in this world, Bear MacKenzie seemed the least likely to ever die before me.”")]), _c('p', {
    attrs: {
      "id": "p227"
    }
  }, [_vm._v("Taking a deep breath, he opened his briefcase and removed a sheaf of papers. “Willow, you asked me to try to locate Ash, to alert him of his father’s death.”")]), _c('p', {
    attrs: {
      "id": "p228"
    }
  }, [_vm._v("She looked up hopefully. “You found him?”")]), _c('p', {
    attrs: {
      "id": "p229"
    }
  }, [_vm._v("“It took some digging, but Lance located him on a ranch in Wyoming.”")]), _c('p', {
    attrs: {
      "id": "p230"
    }
  }, [_vm._v("Whit’s head came up. “Are you telling me that all the time we’ve needed help here, my brother’s been working for someone else?”")]), _c('p', {
    attrs: {
      "id": "p231"
    }
  }, [_vm._v("Lance shook his head. “He works for himself. It’s Ash’s ranch. It was small when he bought it, but he acquired the land on either side until it’s grown into quite a spread.”")]), _c('p', {
    attrs: {
      "id": "p232"
    }
  }, [_vm._v("While his son spoke, Mason handed Willow a document, which she scanned quickly before handing it over to Maddock.")]), _c('p', {
    attrs: {
      "id": "p233"
    }
  }, [_vm._v("The old man looked it over. “So much land. The lad took quite a gamble buying that much.”")]), _c('p', {
    attrs: {
      "id": "p234"
    }
  }, [_vm._v("Mason nodded. “Seems to me gambling runs in the family.”")]), _c('p', {
    attrs: {
      "id": "p235"
    }
  }, [_vm._v("That had Maddock smiling. “Yeah. But a gambler’s got to be prepared to lose as often as he wins.”")]), _c('p', {
    attrs: {
      "id": "p236"
    }
  }, [_vm._v("“That could be in Ash’s not-too-distant future.” Mason pointed to the upper portion of the document before turning to his son to let him explain.")]), _c('p', {
    attrs: {
      "id": "p237"
    }
  }, [_vm._v("Lance said matter-of-factly, “If Ash can’t come up with enough to pay some heavy-duty debts, he could lose everything, including the original ranch. Right now, with family holdings being auctioned off every week, I wouldn’t put my money on Ash beating the odds.”")]), _c('p', {
    attrs: {
      "id": "p238"
    }
  }, [_vm._v("Willow interrupted. “Has he been notified about his father’s death?”")]), _c('p', {
    attrs: {
      "id": "p239"
    }
  }, [_vm._v("Lance shook his head. “I have an associate driving out there now. Dad didn’t think it was something you’d want him to hear over the phone.”")]), _c('p', {
    attrs: {
      "id": "p240"
    }
  }, [_vm._v("“No.” She turned to the old lawyer. “Thank you for thinking of that, Mason.”")]), _c('p', {
    attrs: {
      "id": "p241"
    }
  }, [_vm._v("He patted her shoulder.")]), _c('p', {
    attrs: {
      "id": "p242"
    }
  }, [_vm._v("She folded her hands atop the table. “Do you have a phone number for Ash?”")]), _c('p', {
    attrs: {
      "id": "p243"
    }
  }, [_vm._v("Lance spoke for his father. “There’s no landline. I figure he has only a cell. But I’ll have that information for you by tomorrow evening.”")]), _c('p', {
    attrs: {
      "id": "p244"
    }
  }, [_vm._v("“Thank you. I need to hear his voice. To know that he’ll be here for his family.”")]), _c('p', {
    attrs: {
      "id": "p245"
    }
  }, [_vm._v("She started to shove away from the table, but Mason and Lance exchanged a look before Mason stopped her. “There’s something else.”")]), _c('p', {
    attrs: {
      "id": "p246"
    }
  }, [_vm._v("At the tone of his voice she sat back down and arched a brow. “This sounds like bad news, Mason.”")]), _c('p', {
    attrs: {
      "id": "p247"
    }
  }, [_vm._v("The older lawyer cleared his throat. “Do you remember a woman named Melinda Warren?”")]), _c('p', {
    attrs: {
      "id": "p248"
    }
  }, [_vm._v("“Sorry. No.” Willow shook her head. “Should I?”")]), _c('p', {
    attrs: {
      "id": "p249"
    }
  }, [_vm._v("“She was a teacher in Copper Creek until she left town about thirty years ago.”")]), _c('p', {
    attrs: {
      "id": "p250"
    }
  }, [_vm._v("Willow shrugged. “Then she wouldn’t have taught either Ash or Whit. What’s this about, Mason?”")]), _c('p', {
    attrs: {
      "id": "p251"
    }
  }, [_vm._v("The lawyer frowned and tapped a pen on the stack of papers in front of him. “Maybe you’d prefer the privacy of Bear’s office, where we could talk alone.”")]), _c('p', {
    attrs: {
      "id": "p252"
    }
  }, [_vm._v("Willow sat up straighter. “Now you’ve got me worried, Mason. Why don’t you just say whatever it is you have to say and get it over with?”")]), _c('p', {
    attrs: {
      "id": "p253"
    }
  }, [_vm._v("He took in a breath. “After leaving Copper Creek, Melinda Warren settled in Billings and taught school there for the past twenty-nine years. When she was recently diagnosed with a terminal illness, and learned that she had only a short time to live, she wanted to set the record straight for the sake of her only son and heir. Bear got a letter documenting the birth of a boy, Griff Warren, to Melinda Warren, formerly of Copper Creek, Montana, and listing Bear as the biological father. He was stunned and brought the documents to me to have all the facts verified. From time to time,” he added softly, “I employ some very discreet investigators.”")]), _c('p', {
    attrs: {
      "id": "p254"
    }
  }, [_vm._v("Willow’s eyes were wide and unblinking.")]), _c('p', {
    attrs: {
      "id": "p255"
    }
  }, [_vm._v("Across the table, Whit and Maddock had gone as still as statues, while the foreman kept his gaze fixed on Willow’s pale face.")]), _c('p', {
    attrs: {
      "id": "p256"
    }
  }, [_vm._v("“That would have been the time you broke your engagement to Bear and flew to New York about that modeling job, Willow.” Mason’s tone lowered. “At least that’s the way Bear remembered it. He said he was like a wounded grizzly, and the pretty young teacher was willing to give aid and comfort. A month or so later you were back in Montana, and back in Bear’s life. He swore to me that he never saw the teacher again, and when she left town, he didn’t have a clue that she was having a baby. His baby. Apparently she told nobody, not even her son, about the affair. She never married. But when she learned that she was dying, she wanted her son to have a chance at a real family.”")]), _c('p', {
    attrs: {
      "id": "p257"
    }
  }, [_vm._v("Whit’s eyes blazed. “Are you saying you want to bring that bastard here, Mason?”")]), _c('p', {
    attrs: {
      "id": "p258"
    }
  }, [_vm._v("“I’m saying that when the results of a DNA test proved her claim once and for all, your father asked me to contact this Griff Warren, to arrange an introduction, and to list him in his will as his son and legal heir. Bear thought it was the right thing to do. The letter went out weeks ago.”")]), _c('p', {
    attrs: {
      "id": "p259"
    }
  }, [_vm._v("“Weeks ago.” Whit leaned forward. “Could it be that you’ve just found Pop’s killer?”")]), _c('p', {
    attrs: {
      "id": "p260"
    }
  }, [_vm._v("Mason shook his head. “That thought occurred to me, too. He certainly had a motive. But I learned that Griff is currently serving with the Marine Corps in Afghanistan.” He spread his hands, palms upward. “I’m sorry to be the messenger of such painful news, especially at a time like this. But Willow, it was Bear’s intention to invite this stranger here when he returned to the States and give him the opportunity to be part of the family.”")]), _c('p', {
    attrs: {
      "id": "p261"
    }
  }, [_vm._v("Willow’s voice sounded suddenly weary. “What of the mother?”")]), _c('p', {
    attrs: {
      "id": "p262"
    }
  }, [_vm._v("“Dead.”")]), _c('p', {
    attrs: {
      "id": "p263"
    }
  }, [_vm._v("She hissed in a breath. “And now this stranger…Griff Warren…will have to be told that his father is dead, too. Does he know yet?”")]), _c('p', {
    attrs: {
      "id": "p264"
    }
  }, [_vm._v("“The Red Cross has notified him. When he responds…if he chooses to respond…I’ll let you know, of course.” Mason turned to Whit. “But there’s a good chance he’ll want nothing to do with any of you.”")]), _c('p', {
    attrs: {
      "id": "p265"
    }
  }, [_vm._v("As the silence stretched out, Lance removed several documents from his briefcase. “I’ve brought copies of Bear’s amended will. He added the latest changes as soon as he learned about this…surprise.” He studied the stricken look on the pretty widow’s face. “You should know that Bear was as shocked as you at the news. But once he processed it, he was determined to do the right thing for this…son he never knew.”")]), _c('p', {
    attrs: {
      "id": "p266"
    }
  }, [_vm._v("Whit was on his feet. “Are you saying my father put this bastard in his will?”")]), _c('p', {
    attrs: {
      "id": "p267"
    }
  }, [_vm._v("“Whit…” Willow reached for her son’s hand, but he snatched it away.")]), _c('p', {
    attrs: {
      "id": "p268"
    }
  }, [_vm._v("“Tell me.” Whit’s eyes blazed with fury. “Did he leave any part of this ranch to a stranger?”")]), _c('p', {
    attrs: {
      "id": "p269"
    }
  }, [_vm._v("Lance glanced at his father before the older man nodded. “He did, Whit. He told me that he knew how painful this would be for everyone, but he figured Griff Warren was the innocent victim in all this. He said a fatherless kid probably paid a dear price for the mistakes of his parents in the past. Bear didn’t want to make things worse by denying him a future.”")]), _c('p', {
    attrs: {
      "id": "p270"
    }
  }, [_vm._v("“So he just cut up the family ranch to include this stranger?”")]), _c('p', {
    attrs: {
      "id": "p271"
    }
  }, [_vm._v("“The ranch was Bear’s to do with as he pleased.” Without looking at Whit, Lance passed the documents to Willow. “I’ll leave these amendments for you to read. If you have any questions, you know where to reach me.”")]), _c('p', {
    attrs: {
      "id": "p272"
    }
  }, [_vm._v("The older lawyer snapped shut his briefcase and stood before offering his hand to Maddock. “Again, I wish you didn’t have to endure this pain, Mad.”")]), _c('p', {
    attrs: {
      "id": "p273"
    }
  }, [_vm._v("“Thanks, Mason.”")]), _c('p', {
    attrs: {
      "id": "p274"
    }
  }, [_vm._v("The lawyer shook Whit’s hand without a word before drawing Willow close for a firm hug.")]), _c('p', {
    attrs: {
      "id": "p275"
    }
  }, [_vm._v("“You call me anytime, with anything you need to know. You hear?” He patted her shoulder. She nodded, as he added, “We’ll let ourselves out.”")]), _c('p', {
    attrs: {
      "id": "p276"
    }
  }, [_vm._v("Behind him, his son followed with handshakes all around, then the two men headed for the door. In the back room they retrieved their hats before stepping into the rain-drenched night.")]), _c('p', {
    attrs: {
      "id": "p277"
    }
  }, [_vm._v("In the kitchen, the four figures remained at the table, lost in thought, until Willow snatched up the documents and got to her feet.")]), _c('p', {
    attrs: {
      "id": "p278"
    }
  }, [_vm._v("Before she could leave, Maddock reached for her hand.")]), _c('p', {
    attrs: {
      "id": "p279"
    }
  }, [_vm._v("“I remember that time, when you broke the engagement and flew to New York.”")]), _c('p', {
    attrs: {
      "id": "p280"
    }
  }, [_vm._v("Willow held her silence, while pain and anger warred in her eyes.")]), _c('p', {
    attrs: {
      "id": "p281"
    }
  }, [_vm._v("“You were gone for over a month.”")]), _c('p', {
    attrs: {
      "id": "p282"
    }
  }, [_vm._v("“Six weeks.” Her words were stiff.")]), _c('p', {
    attrs: {
      "id": "p283"
    }
  }, [_vm._v("“To Bear, it seemed like a lifetime.”")]), _c('p', {
    attrs: {
      "id": "p284"
    }
  }, [_vm._v("“Really?” Her voice nearly broke. “ It’s nice to know he managed to find some…comfort.”")]), _c('p', {
    attrs: {
      "id": "p285"
    }
  }, [_vm._v("Maddock held her hand firmly when she tried to pull away. “Men grieve differently than women, lassie. As I recall, you went on a modeling assignment to some sun-drenched island and had yourself a fine time. ”")]), _c('p', {
    attrs: {
      "id": "p286"
    }
  }, [_vm._v("“Where I worked from sunup to sundown. And when it was over, I realized it wasn’t the life I wanted. I came home. Back to Bear, who acted like a man who’d been on a starvation diet and I was a feast.”")]), _c('p', {
    attrs: {
      "id": "p287"
    }
  }, [_vm._v("“You were, lass. He may have taken comfort with someone else, but you need to know this. Bear never loved anyone but you. And from the day you married him, he never even looked at another woman.”")]), _c('p', {
    attrs: {
      "id": "p288"
    }
  }, [_vm._v("“How would you know, Mad? Were you with him day and night?”")]), _c('p', {
    attrs: {
      "id": "p289"
    }
  }, [_vm._v("“I’m his father. I know. My son was a one-woman man. In Bear’s eyes, in his heart, the sun rose and set on you, lassie. Don’t you ever forget that.”")]), _c('p', {
    attrs: {
      "id": "p290"
    }
  }, [_vm._v("She did pull free then, and strode quickly out of the room.")]), _c('p', {
    attrs: {
      "id": "p291"
    }
  }, [_vm._v("The three men sat in the kitchen, listening to the sound of her footsteps on the stairs. Minutes later they heard the slamming of her bedroom door.")]), _c('p', {
    attrs: {
      "id": "p292"
    }
  }, [_vm._v("And then there was only the sound of the rain streaming down the windowpanes like tears.")]), _c('div', {
    staticClass: "leading-line-rw",
    attrs: {
      "id": "leading-line4"
    }
  }, [_c('p', {
    attrs: {
      "id": "p293"
    }
  })]), _c('p', {
    attrs: {
      "id": "p294"
    }
  }, [_vm._v("Morning dawned clear and bright.")]), _c('p', {
    attrs: {
      "id": "p295"
    }
  }, [_vm._v("Willow sat slumped on the edge of the king-sized bed, her mind in turmoil. It was all too much to take in. Bear dead. Shot in the back by a cowardly killer. He was never coming back. Never going to fill the room with that booming laugh, or rattle off every rich, ripe curse in a voice that could freeze a man’s blood when he’d been crossed.")]), _c('p', {
    attrs: {
      "id": "p296"
    }
  }, [_vm._v("Since the moment she’d heard Ira Pettigrew say those words, she’d been unable to make sense of them. How was it possible that Bear had been murdered?")]), _c('p', {
    attrs: {
      "id": "p297"
    }
  }, [_vm._v("Willow unconsciously clenched her fists. She couldn’t even imagine anyone, friend or foe, daring to threaten Bear MacKenzie, let alone any man following through with such a threat.")]), _c('p', {
    attrs: {
      "id": "p298"
    }
  }, [_vm._v("You just didn’t kill a man like Bear MacKenzie.")]), _c('p', {
    attrs: {
      "id": "p299"
    }
  }, [_c('i', [_vm._v("But someone did.")])]), _c('p', {
    attrs: {
      "id": "p300"
    }
  }, [_vm._v("And now, to learn that the man she’d loved and trusted more than anyone in this world had betrayed her, was almost more than she could take in. Oh, it might be true that he hadn’t cheated while they were married. But that didn’t alter the fact that he’d fathered a son with another woman. A son who might or might not decide to satisfy his curiosity about the man who’d been absent from his life, and come here to further complicate things.")]), _c('p', {
    attrs: {
      "id": "p301"
    }
  }, [_vm._v("It had been such a source of pride to her that she’d been the great, the only, love of Bear MacKenzie’s life. To learn now, while grieving his sudden, shocking death, that there had been another woman, the mother of his firstborn son, was almost too painful to bear.")]), _c('p', {
    attrs: {
      "id": "p302"
    }
  }, [_vm._v("Too agitated to sit, she got up, walked to the window, and stared at the tranquil morning scene spread out below. For as far as the eye could see there were hills dotted with herds of cattle. Their gentle lowing drifted through the closed windowpane. A truck was moving along the ribbon of road that led from the highway to their ranch. A tractor rolled out from behind the barn. Up on the north hill Whit was on an all-terrain vehicle, trailed by several horsemen, heading up to high country.")]), _c('p', {
    attrs: {
      "id": "p303"
    }
  }, [_vm._v("It all was so deceptively peaceful. But she knew that everyone on this ranch was reeling. For that matter, everyone in the town of Copper Creek, whose life had been touched by her husband, had to be experiencing this sick feeling in the pit of their stomachs.")]), _c('p', {
    attrs: {
      "id": "p304"
    }
  }, [_vm._v("Everyone except the shooter.")]), _c('p', {
    attrs: {
      "id": "p305"
    }
  }, [_vm._v("“Why, Bear?” The words were torn from her lips and the tears welled up again, spilling down her cheeks.")]), _c('p', {
    attrs: {
      "id": "p306"
    }
  }, [_vm._v("It had been like this ever since she’d heard the news. This sudden, wrenching grief that had her throat raw, her heart breaking over and over, until she thought she’d go mad from the pain.")]), _c('p', {
    attrs: {
      "id": "p307"
    }
  }, [_vm._v("“I can’t do this.” She paced the length of her room and back, letting the tears fall. “I don’t even know where to begin without you here. Whit thinks he can step into your shoes, Bear, but he’s wrong. He’s not ready yet. And Maddock may be wise enough, and tough enough, but his body won’t let him do what he once did.”")]), _c('p', {
    attrs: {
      "id": "p308"
    }
  }, [_vm._v("She slumped back onto the edge of the bed and buried her face in her hands. Bear was dead. Though she hadn’t yet been allowed to see his body, Ira Pettigrew had said so.")]), _c('p', {
    attrs: {
      "id": "p309"
    }
  }, [_vm._v("Her hands suddenly clenched. She couldn’t do this. Couldn’t run this ranch alone. And certainly couldn’t handle the arrival of a stranger claiming to be her husband’s son. She had an almost overpowering desire to run and hide. She would rather be anywhere than here, dealing with the mountain of misery that had been dumped on her.")]), _c('p', {
    attrs: {
      "id": "p310"
    }
  }, [_vm._v("She stared at her clenched fists and slowly opened them. She’d had a good life with Bear.")]), _c('p', {
    attrs: {
      "id": "p311"
    }
  }, [_vm._v("Bear MacKenzie was the strongest, smartest man she’d ever met. He was her husband, her mentor, her protector. Her best friend.")]), _c('p', {
    attrs: {
      "id": "p312"
    }
  }, [_vm._v("He’d literally ridden into her young life like an avenging angel. Her father had been a teacher and part-time rancher. Her mother had raised chickens and cooked a fine chicken dinner once a month as a fund-raiser for the Copper Creek Church. They had been standing with their daughter beside their broken-down van when the most handsome cowboy Willow had ever seen rode up on his horse and offered to help. He’d fiddled under the hood and got their van started, then followed along all the way to town to make certain they arrived safely. Then he’d stayed to enjoy her mother’s cooking and had flirted shamelessly with tall, slender Willow Martin, a sun-bronzed, blonde college junior home for the summer. By the time she returned for her senior year, she was wildly in love with her cowboy and sorely tempted to abandon her plans to go to New York and become a model. And though she gave modeling a try after graduation, she simply couldn’t stop missing the man who had stolen her heart.")]), _c('p', {
    attrs: {
      "id": "p313"
    }
  }, [_vm._v("After that singular modeling assignment, she had returned to Bear’s arms. Once married, Willow had embraced ranching with an all-consuming passion.")]), _c('p', {
    attrs: {
      "id": "p314"
    }
  }, [_vm._v("She blinked, struggling to put aside her gut-wrenching musings of the past and think of something positive to hold on to this day.")]), _c('p', {
    attrs: {
      "id": "p315"
    }
  }, [_vm._v("She had a father-in-law and sons who would no doubt do whatever they could to ease the road that lay ahead. She had a strong, loyal foreman. And in truth, whatever doubts plagued her, she would have to find her way through the layers of grief, anger, fear, confusion, and utter despair, and uncover her strengths.")]), _c('p', {
    attrs: {
      "id": "p316"
    }
  }, [_vm._v("She would deal with all of this because she had no choice. The hand had been dealt. Now, like it or not, all she could do was play the cards.")]), _c('div', {
    staticClass: "leading-line-rw",
    attrs: {
      "id": "leading-line5"
    }
  }, [_c('p', {
    attrs: {
      "id": "p317"
    }
  })]), _c('p', {
    attrs: {
      "id": "p318"
    }
  }, [_vm._v("The voices in the kitchen were muted.")]), _c('p', {
    attrs: {
      "id": "p319"
    }
  }, [_vm._v("Brady was saying, “I’ve already given orders to the wranglers. Since we don’t know who shot Bear, or why, I want someone looking out for Willow at all times. Wherever she goes, one of us goes with her.”")]), _c('p', {
    attrs: {
      "id": "p320"
    }
  }, [_vm._v("Mad nodded his agreement. “You’re a step ahead of me, laddie.”")]), _c('p', {
    attrs: {
      "id": "p321"
    }
  }, [_vm._v("Whit’s eyes narrowed. “You think the shooter will come after Mom?”")]), _c('p', {
    attrs: {
      "id": "p322"
    }
  }, [_vm._v("The foreman shrugged one powerful shoulder. “Right now I don’t know what to think. But until we know the who and why of this mess, we need to take precautions.”")]), _c('p', {
    attrs: {
      "id": "p323"
    }
  }, [_vm._v("“I agree.” Mad clenched a fist on the arm of his wheelchair. “If there’s a grudge against Bear, what better way to pay it back than to kill the woman he loved, too?”")]), _c('p', {
    attrs: {
      "id": "p324"
    }
  }, [_vm._v("“But why? What would be the point of killing Mom now? With Pop gone, it’s too late to hurt him.”")]), _c('p', {
    attrs: {
      "id": "p325"
    }
  }, [_vm._v("“For all we know, the whole family could be targeted.” Brady stared into Whit’s stormy eyes.")]), _c('p', {
    attrs: {
      "id": "p326"
    }
  }, [_vm._v("Mad nodded his agreement. “Just to be safe, whenever you’re off the ranch, I think you should travel with one of the wranglers, lad.”")]), _c('p', {
    attrs: {
      "id": "p327"
    }
  }, [_vm._v("“You want me to have a babysitter?”")]), _c('p', {
    attrs: {
      "id": "p328"
    }
  }, [_vm._v("Mad placed a hand on his grandson’s arm. “Think of it as the buddy system. Whenever you went swimming in Copper Creek as a lad, I always told you to take along Ash or one of the wranglers, just in case.”")]), _c('p', {
    attrs: {
      "id": "p329"
    }
  }, [_vm._v("“I was six, Mad. I’m not a kid anymore.”")]), _c('p', {
    attrs: {
      "id": "p330"
    }
  }, [_vm._v("“It’s just a precaution.” Brady lowered his voice, hoping Willow didn’t choose that moment to come downstairs and catch them conspiring. “But especially where your mother is concerned, I don’t want her alone until this matter is resolved.”")]), _c('p', {
    attrs: {
      "id": "p331"
    }
  }, [_vm._v("When Whit gave a slight nod of his head, both men breathed a sigh of relief.")]), _c('p', {
    attrs: {
      "id": "p332"
    }
  }, [_vm._v("It was just another minor bump in a week that had seen one major crisis after another.")]), _c('p', {
    attrs: {
      "id": "p333"
    }
  }, [_vm._v("They were all bracing for whatever might happen next.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14e8ea7e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/s006-Chapter-003.vue
// module id = 75
// module chunks = 0